var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.759,
    height: 71.547,
    viewBox: "0 0 72.759 71.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6216",
    "data-name": "Group 6216",
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47490",
    "data-name": "Path 47490",
    d: "M264,74.334h31.529V4H264V22.19",
    transform: "translate(-223.982)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47491",
    "data-name": "Path 47491",
    d: "M48.912,134.3a3,3,0,0,0-4.015-1.382l-.032.016-5.348,2.708-.343.027-3.017-5.093a7.1,7.1,0,1,0-5.083-2.207l-1.956-.849L18.984,131.8a3.045,3.045,0,0,0-1.843,2.111l-2.012,8.149a3.058,3.058,0,0,0,2.195,3.706,3.012,3.012,0,0,0,3.651-2.194l.007-.03,1.631-6.609,5.5-2.281-2.011,11.2-7.176,8.041L13,148.646a2.988,2.988,0,0,0-4.219.244l-.038.043a3.083,3.083,0,0,0,.284,4.312l8.045,7.13a2.989,2.989,0,0,0,4.123-.139l8.387-8.5,7.283,4.427,4.635,9.39a3.013,3.013,0,0,0,2.7,1.69,2.973,2.973,0,0,0,1.347-.324,3.077,3.077,0,0,0,1.35-4.1l-5.029-10.186a3.049,3.049,0,0,0-1.146-1.254l-8.191-4.972,1.707-7.783,1.227,2.487a3.016,3.016,0,0,0,2.7,1.69,2.969,2.969,0,0,0,1.347-.324l8.045-4.075a3.075,3.075,0,0,0,1.35-4.106Z",
    transform: "translate(-6.788 -95.336)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47492",
    "data-name": "Path 47492",
    d: "M322.1,210.52a1.212,1.212,0,0,0,0-.926,1.2,1.2,0,0,0-.263-.4l-4.851-4.851a1.213,1.213,0,1,0-1.715,1.715l2.782,2.782H305.213a1.213,1.213,0,0,0,0,2.425H318.05l-2.781,2.781a1.213,1.213,0,1,0,1.715,1.715l4.851-4.851A1.2,1.2,0,0,0,322.1,210.52Z",
    transform: "translate(-257.919 -169.677)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47493",
    "data-name": "Path 47493",
    d: "M71.547,462.425H1.213a1.213,1.213,0,0,1,0-2.425H71.547a1.213,1.213,0,0,1,0,2.425Z",
    transform: "translate(0 -386.879)",
    fill: "#f2f2f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.78581eb11fbdee9a0bc6b61e63f867ba.svg";
export { ForwardRef as ReactComponent };